import { TStore } from "redux/reducer";

export const selectUserState = (state: TStore) => state.user;
